export default __webpack_public_path__ + "static/banner-bb07a2a478d016c793823bd404c46916.png";